import styled from "styled-components";

export const CouponModalStyle = styled.div`
  .error-input {
    height: 4vh;
    margin-bottom: 5px;
    font-family: light-pro, sans-serif;
    border-color: red;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    font-family: light-pro, sans-serif;
    font-size: 0.9rem;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }

  .text-error {
    font-family: light-pro, sans-serif;
    color: red;
    font-size: 0.7rem;
    margin-left: 2px;
    margin-bottom: 0;
  }

  .input-div {
    display: flex;
  }

  .text {
    font-family: medium-pro, sans-serif;
  }
  .bootstrap-btn {
    font-family: medium-pro, sans-serif !important;
    margin-bottom: 0;
  }
  .form-control {
    font-family: light-pro, sans-serif;
  }
  .form-button3 {
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 16px;
    padding: 7px 8px;
    align-self: center;
    margin-right: 5px;
  }

  .space-div {
    height: 10px;
  }

  .details-div {
    display: flex;
    font-family: medium-pro, sans-serif;
  }

  .detail-heading {
    font-weight: bold;
  }

  .dropdown {
    font-family: light-pro, sans-serif;
  }
  .dropdown-item2 {
    font-family: light-pro, sans-serif;
  }
  .dropDown-custom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    /* color: var(--bs-dropdown-link-hover-color); */
    color: white;
    /* background-color: var(--bs-dropdown-link-hover-bg); */
    background-color: #ed9e44;
    cursor: pointer;
  }

  .menu2 {
    width: 100%;
  }

  .table-container {
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }

  .table-div {
    padding: 20px;
    display: flex;
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 20px;
    align-self: center;
  }

  .table-loading {
    text-align: center;
  }

  .search-bar {
    display: flex;
    align-items: center;
    border: 1px solid black;
    border-radius: 20px;
    width: 290px;
    background-color: white;
    padding: 0 15px 0 5px;
    margin-bottom: 10px;
    align-self: end;
  }

  .search-input {
    flex: 1;
    border: none;
    outline: none;
    padding: 5px;
    border-radius: 16px;
    font-family: light-pro, sans-serif;
  }

  .filter-div {
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
  }

  .search-icon {
    color: black;
    font-size: 20px;
    cursor: pointer;
  }
`;
